import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Autosuggest from 'react-autosuggest';

import _ from 'lodash';

import '../../styles/Analytics.css';

import BracketAnalytics from '../../containers/moment/BracketAnalytics';
import PicksAnalytics from '../../containers/moment/PicksAnalytics';

import { formatDateAndTime } from '../../../../../utils/time';

import QuestionsAnalytics from '../../containers/moment/QuestionsAnalytics';

const styles = theme => ({
  content: {
    backgroundColor: '#F4F8F9',
    flexGrow: 1,
    padding: theme.spacing(2),
  },
  paper: {
    color: theme.palette.text.secondary,
    marginBottom: 24,
    display: 'flex',
    flexDirection: 'column',
  },

  subtitle: {
    ...theme.Typography,
    color: '#044591',
    marginTop: '10px',
    marginLeft: '18px',
  },
});

const getSuggestions = (value, momentsList) => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;
  return inputLength === 0
    ? momentsList
    : momentsList.filter(
        field => field.name.toLowerCase().slice(0, inputLength) === inputValue
      );
};

function renderMomentSuggestion(suggestion) {
  return (
    <span key={suggestion.id}>
      {suggestion.name} - {formatDateAndTime(suggestion.publishedAt)}
    </span>
  );
}

class MomentAnalyticsHome extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldInput: false,
      valueInput: false,
      value: '',
      momentSuggestions: [],
      momentSelected: {},
    };
  }

  onMomentSuggestionsFetchRequested = ({ value }) => {
    const momentsList = this.props.momentsList;
    this.setState({
      momentSuggestions: getSuggestions(value, momentsList),
    });
  };

  onMomentSuggestionsClearRequested = () => {
    this.setState({
      momentSuggestions: [],
    });
  };

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
    });
  };

  momentAnalytics() {
    const momentType = _.get(this.state.momentSelected, 'type', '');
    const momentId = _.get(this.state.momentSelected, '_id', null);
    switch (momentType.toLowerCase()) {
      case 'trivia':
      case 'prediction':
        return (
          <React.Fragment key={momentId}>
            <Grid item xs={12} sm={12}>
              <QuestionsAnalytics interaction={this.state.momentSelected} />
            </Grid>
          </React.Fragment>
        );

      case 'picks':
        return (
          <React.Fragment key={momentId}>
            <Grid item xs={12} sm={12} style={{ width: 100 }}>
              <PicksAnalytics interaction={this.state.momentSelected} />
            </Grid>
          </React.Fragment>
        );
      case 'swin':
        return 'Analytics Swin';
      case 'brackets':
        return (
          <React.Fragment key={momentId}>
            <Grid item xs={12} sm={12} style={{ width: 100 }}>
              <BracketAnalytics interaction={this.state.momentSelected} />
            </Grid>
          </React.Fragment>
        );
      default:
        return null;
    }
  }

  render() {
    const { classes } = this.props;

    const { value, momentSuggestions } = this.state;

    const getSuggestionValue = suggestion => {
      return suggestion;
    };

    const inputProps = {
      placeholder: 'Type a moment name',
      value,
      onChange: (form, { newValue, method }) => {
        if (method === 'click' || method === 'enter') {
          this.setState({
            momentSelected: newValue,
          });
          newValue = newValue.name + ' - ' + formatDateAndTime(newValue.publishedAt);
        }
        this.setState({
          value: newValue,
        });
      },
    };

    return (
      <div className={classes.content}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Paper className={classes.paper} elevation={0}>
              <Grid container>
                <Grid item xs={12}>
                  <Typography
                    className={classes.subtitle}
                    variant="subtitle1"
                    gutterBottom
                  >
                    Moment
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  <Autosuggest
                    name="field"
                    suggestions={momentSuggestions}
                    onSuggestionsFetchRequested={this.onMomentSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onMomentSuggestionsClearRequested}
                    getSuggestionValue={getSuggestionValue}
                    renderSuggestion={suggestion => renderMomentSuggestion(suggestion)}
                    inputProps={inputProps}
                    alwaysRenderSuggestions={false}
                  />
                </Grid>
              </Grid>
            </Paper>
            <Grid container spacing={1}>
              {this.momentAnalytics()}
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(MomentAnalyticsHome);
